import React from 'react';
import { Link } from 'react-router-dom';
import { ChevronRight } from 'lucide-react';

// Lightweight, SEO-friendly breadcrumb trail.
// `items`: ordered top-down [{ name, to? }]. The last item is the current page
// (rendered as bold, non-clickable). Pass `to` on every other item to link it.
export const Breadcrumbs = ({ items = [], className = '' }) => {
  if (!items.length) return null;
  return (
    <nav
      aria-label="Breadcrumb"
      className={`flex items-center flex-wrap gap-x-1 gap-y-0.5 text-xs text-[#5C5C5C] ${className}`}
      data-testid="breadcrumbs"
    >
      {items.map((it, i) => {
        const last = i === items.length - 1;
        return (
          <span key={`${it.name}-${i}`} className="flex items-center gap-x-1">
            {i > 0 && <ChevronRight className="w-3 h-3 text-[#C7C7C7] shrink-0" />}
            {last || !it.to ? (
              <span
                className={last ? 'text-[#121212] font-medium' : ''}
                data-testid={`breadcrumb-item-${i}`}
                aria-current={last ? 'page' : undefined}
              >
                {it.name}
              </span>
            ) : (
              <Link
                to={it.to}
                className="hover:text-[#D97736] hover:underline transition-colors"
                data-testid={`breadcrumb-item-${i}`}
              >
                {it.name}
              </Link>
            )}
          </span>
        );
      })}
    </nav>
  );
};

// Build a schema.org BreadcrumbList JSON-LD object from the same items.
export const breadcrumbJsonLd = (items, origin) =>
  ({
    '@context': 'https://schema.org',
    '@type': 'BreadcrumbList',
    itemListElement: items.map((it, i) => ({
      '@type': 'ListItem',
      position: i + 1,
      name: it.name,
      ...(it.to ? { item: `${origin}${it.to}` } : {}),
    })),
  });

export default Breadcrumbs;
